import parseUrl from 'url-parse';

export default function isOuinexMarketDomain(url) {
  const domain = parseUrl(url);
  return ['ouinex-uat.cryptosrvc.com', 'ouinex-demo.cryptosrvc.com', 'ouinex.cryptosrvc.com'].includes(domain?.host.trim());
}
